<template>
  <div id="app">
    <div v-if="isShow">
      <Navbar />
      <router-view />
      <Footer />
      <Tool v-if="isTool" />
    </div>
    <router-view v-else />
  </div>
</template>

<script>
import Navbar from "./components/Navbar.vue";
import Footer from "./components/Footer.vue";
import Tool from "./components/Tool.vue";
export default {
  name: "App",
  components: {
    Navbar,
    Footer,
    Tool,
  },
  data() {
    return {
      // 是否首页
      isHome: false,
      // 是否显示公共组建
      isShow: false,
      // 是否显示工具
      isTool: false,
    };
  },
  watch: {
    $route() {
      this.isHome =
        this.$route.path === "/Home" || this.$route.path === "/home";
      this.isShow = this.$route.path !== "/Vescor";
    },
  },
  // 监听页面滚动到一定区域在显示工具
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  // created() {
  //   // 检测是否为手机端
  //   if (this.isMobile()) {
  //     // 替换为实际的移动端地址
  //     window.location.href = `${window.location.origin}/H5/#`; 
  //   }
  //   this.isHome = this.$route.path === "/Home" || this.$route.path === "/home";
  //   this.isShow = this.$route.path !== "/Vescor";
  // },
  methods: {
    // 检测是否为手机端的方法
    // isMobile() {
    //   return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    // },
    handleScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.isTool = scrollTop > 200;
    },
  },
};
</script>
<style>
.other {
  padding-top: 130px;
  box-sizing: border-box;
}

/* .f-shsc-l {
  font-family: "SourceHanSansCN-Light", sans-serif;
}
.f-shsc-m {
  font-family: "SourceHanSansCN-Medium", sans-serif;
}
.f-shsc-n {
  font-family: "SourceHanSansCN-Normal", sans-serif;
}
.f-shsc-r {
  font-family: "SourceHanSansCN-Regular", sans-serif;
}
.f-shscb {
  font-family: "SourceHanSerifCN-Bold", serif;
}
.f-shscm {
  font-family: "SourceHanSerifCN-Medium", serif;
} */
body {
  font-family: "SourceHanSansCN-Normal", sans-serif !important;
}
</style>

